import { FileText, X } from "lucide-react";

const tone = (used, limit) => {
  if (used >= limit) return { box: "bg-rose-50 border-rose-300 text-rose-800", bar: "bg-rose-500", note: "Full — start a new invoice" };
  if (limit - used <= 2) return { box: "bg-amber-50 border-amber-300 text-amber-800", bar: "bg-amber-500", note: `${limit - used} left` };
  return { box: "bg-emerald-50 border-emerald-200 text-emerald-800", bar: "bg-emerald-500", note: `${limit - used} left` };
};

const Badge = ({ o, testid, showName, onPick, active }) => {
  const used = o.running_parcels || 0, limit = o.running_limit || 12;
  const t = tone(used, limit);
  return (
    <div role={onPick ? "button" : undefined} onClick={onPick ? () => onPick(o.running_invoice) : undefined}
      className={`inline-flex flex-wrap items-center gap-x-2 gap-y-0.5 rounded-lg border px-2.5 py-1 text-xs ${t.box} ${onPick ? "cursor-pointer hover:shadow-md transition-shadow" : ""} ${active ? "ring-2 ring-indigo-500" : ""}`} data-testid={testid}
      title={`${o.owner_name}: invoice ${o.running_invoice} has ${used} of ${limit} parcels${onPick ? " — click to show its rows" : ""}`}>
      <FileText className="w-3.5 h-3.5" />
      {showName && <span className="font-semibold">{o.owner_name}</span>}
      <span className="font-mono font-bold">{o.running_invoice}</span>
      <span className="font-semibold" data-testid={`${testid}-count`}>{used}/{limit} parcels</span>
      <span className="w-14 h-1.5 rounded-full bg-white/70 overflow-hidden"><span className={`block h-full ${t.bar}`} style={{ width: `${Math.min(100, used / limit * 100)}%` }} /></span>
      <span className="text-[10px] font-medium">{t.note}</span>
    </div>
  );
};

// Iter 312 — own running invoice + (admin) every open invoice of every member; click a chip to filter the table.
export const RunningInvoiceBadge = ({ owners, user, isAdmin, onPick, activeInvoice }) => {
  const me = (user?.email || "").toLowerCase();
  const live = (owners || []).filter(o => o.running_invoice);
  const mine = live.find(o => (o.owner_email || "").toLowerCase() === me);
  const others = isAdmin ? live.filter(o => o !== mine) : [];
  if (!mine && others.length === 0) return null;
  const act = String(activeInvoice || "").toUpperCase();
  const chips = (o) => {
    const list = isAdmin && o.invoice_breakdown?.length ? o.invoice_breakdown : [{ invoice: o.running_invoice, parcels: o.running_parcels, limit: o.running_limit }];
    return list.map(b => ({ ...o, running_invoice: b.invoice, running_parcels: b.parcels, running_limit: b.limit || o.running_limit }));
  };
  const render = (o, showName) => chips(o).map(c => (
    <Badge key={`${o.owner_email}-${c.running_invoice}`} o={c} showName={showName} onPick={onPick} active={act === c.running_invoice}
      testid={`or-running-invoice-${showName ? o.owner_email : "mine"}-${c.running_invoice}`} />
  ));
  return (
    <div className="px-3 py-2 mt-1 rounded-lg border border-slate-200 bg-white flex flex-wrap items-center gap-2" data-testid="or-running-invoice-row">
      {mine && <><span className="text-[11px] font-semibold text-slate-500">{isAdmin && mine.invoice_breakdown?.length > 1 ? "Your open invoices:" : "Your running invoice:"}</span>{render(mine, false)}</>}
      {others.length > 0 && (
        <div className="flex flex-wrap items-center gap-1.5" data-testid="or-running-invoice-strip">
          <span className="text-[11px] font-semibold text-slate-500 ml-2">Team:</span>
          {others.flatMap(o => render(o, true))}
        </div>
      )}
      {act && onPick && (
        <button type="button" onClick={() => onPick("")} data-testid="or-running-invoice-clear"
          className="ml-auto inline-flex items-center gap-1 rounded-md border border-slate-300 bg-slate-50 px-2 py-0.5 text-[11px] font-semibold text-slate-600 hover:bg-slate-100">
          <X className="w-3 h-3" /> Clear invoice {act}
        </button>
      )}
    </div>
  );
};
